module.exports = __webpack_public_path__ + "img/react.06f9402.jpg";